import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreatePagamentoSaida,
  IGetDescontoAgendamentoByGateEntradaResponse,
  IGetPagamentoSaidaCaixaList,
  IGetPagamentoSaidaTotalizadoresByEntradaResponse,
  IUpdatePagamentoSaidaCaixa,
  IUpdatePagamentoSaidaCaixaBatch
} from './pagamentoSaida.model';

@Injectable({
  providedIn: 'root'
})
export class PagamentoSaidaService {
  constructor(private http: HttpClient) {}

  public CreatePagamentoSaida(body: ICreatePagamentoSaida, guid: string): Observable<any> {
    const headers = new HttpHeaders({
          IdempotencyKey: guid
        });
        
    return this.http.post<any>(
      `${environment.baseURL}PagamentoSaida/CreatePagamentoSaida`,
      body,
      { headers: headers }
    );
  }

  public UpdatePagamentoSaidaCaixa(
    id: number,
    body: IUpdatePagamentoSaidaCaixa
  ): Observable<any> {
    return this.http.put<any>(
      `${environment.baseURL}PagamentoSaida/UpdatePagamentoSaidaCaixa?id=${id}`,
      body
    );
  }

  public UpdatePagamentoSaidaCaixaBatch(
    body: IUpdatePagamentoSaidaCaixaBatch
  ): Observable<any> {
    return this.http.put<any>(
      `${environment.baseURL}PagamentoSaida/UpdatePagamentoSaidaCaixaBatch`,
      body
    );
  }

  public GetPagamentoSaidaCaixa({
    idPagamentoSaida,
    idGateEntrada,
    idCaixa,
    idServicoEntradaPagamentoSaida
  }: {
    idPagamentoSaida?: number;
    idGateEntrada?: number;
    idCaixa?: number;
    idServicoEntradaPagamentoSaida?: number;
  }): Observable<IGetPagamentoSaidaCaixaList> {
    const invalid = ['', undefined, 0, NaN];
    const url = `${environment.baseURL}PagamentoSaida/GetPagamentosSaidaCaixa`;
    const params: any = {};

    if (!invalid.includes(idPagamentoSaida)) {
      params.PK_PGMT_SAID = idPagamentoSaida;
    }

    if (!invalid.includes(idGateEntrada)) {
      params.FK_GATE_ENTR = idGateEntrada;
    }

    if (!invalid.includes(idCaixa)) {
      params.FK_CAIX = idCaixa;
    }

    if (!invalid.includes(idServicoEntradaPagamentoSaida)) {
      params.FK_SRVC_ENTR_PGMT_SAID = idServicoEntradaPagamentoSaida;
    }

    return this.http.get<IGetPagamentoSaidaCaixaList>(url, { params });
  }

  public GetDescontoAgendamentoByGateEntrada(
    FK_GATE_ENTR: number
  ): Observable<IGetDescontoAgendamentoByGateEntradaResponse> {
    return this.http.get<any>(
      `${environment.baseURL}PagamentoSaida/GetDescontoAgendamentoByGateEntrada?FK_GATE_ENTR=${FK_GATE_ENTR}`
    );
  }

  public GetPagamentoSaidaTotalizadoresByEntrada(
    FK_GATE_ENTR: number
  ): Observable<IGetPagamentoSaidaTotalizadoresByEntradaResponse> {
    return this.http.get<any>(
      `${environment.baseURL}PagamentoSaida/GetPagamentoSaidaTotalizadoresByEntrada?PK_GATE_ENTR=${FK_GATE_ENTR}`
    );
  }
}
